var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 51,
    viewBox: "0 0 54.861 66.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21171",
    "data-name": "Path 21171",
    d: "M30.174,0H0V66.748H54.861V24.688H30.174Z",
    fill: "#3f81f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21172",
    "data-name": "Path 21172",
    d: "M9,45.174H47.4v4.572H9ZM9,55.232H47.4V59.8H9ZM9,35.116H47.4v4.572H9ZM9,25.058H47.4V29.63H9ZM9,15H22.715v4.572H9Z",
    transform: "translate(-0.771 -1.285)",
    fill: "#88b3ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21173",
    "data-name": "Path 21173",
    d: "M33,27H57.688v2.743H33Z",
    transform: "translate(-2.826 -2.312)",
    fill: "#1449a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21174",
    "data-name": "Path 21174",
    d: "M33,24.694H57.688L33,.08Z",
    transform: "translate(-2.826 -0.007)",
    fill: "#2c65c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file_icon.0fc570923e23dfffaf05038b90263ff2.svg";
export { ForwardRef as ReactComponent };